export default __webpack_public_path__ + "static/media/thumbnailLogo.22569fb9.jpg";